export default __webpack_public_path__ + "static/media/Group 390.529f3596.svg";